import { render, staticRenderFns } from "./MutualFundDetails.vue?vue&type=template&id=6ed0d9cb&scoped=true&"
import script from "./MutualFundDetails.vue?vue&type=script&lang=js&"
export * from "./MutualFundDetails.vue?vue&type=script&lang=js&"
import style0 from "./MutualFundDetails.vue?vue&type=style&index=0&id=6ed0d9cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed0d9cb",
  null
  
)

export default component.exports